<template>
	<div id="strategyDetail">
		<v-header :selectedItemVal="2" ref="header"></v-header>
		
		<div class="main">
			<div class="strategyDetail">
				<div class="page_tag">
					<h2>
						首页 &nbsp;> &nbsp; 牛策略 &nbsp;> &nbsp; 牛策略详情
					</h2>
				</div>
				<div class="page_content">
					<div class="article">
						<div class="title">
							{{ strategyData ? strategyData.title : '' }}
						</div>
						<div class="desc">
							<span>文章来源：斗牛财经</span>
							<span>发布时间：{{ strategyData ? strategyData.createTime :'' }}</span>
							<span>作者：{{ strategyData ? strategyData.analystName : ''}}</span>
						</div>
						<div class="content">
							{{ strategyData ? strategyData.text : '' }}
						</div>
					</div>
					<div class="article-piece">
						<div class="piece last-piece">
							<span>上一篇：</span>
							<span>首席实战65165s165df1gsf</span>
						</div>
						<div class="piece next-piece">
							<span>下一篇：</span>
							<span>首席实战sasdf15a65s1d6f1sd51f</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<v-footer></v-footer>
	</div>
</template>

<script>
	import vHeader from '../common/header'
	import vFooter from '../common/footer'
	
	export default{
		name:"strategyDetail",
		data(){
			return {
				//详情文章id
				article_id:0,
				article_type:0,
				strategyData:'',
				lastPieceTitle:'',
				nextPieceTitle:'',
			}
		},
		components:{
			'v-header':vHeader,
			'v-footer':vFooter,
		},
		mounted() {
			//接收详情文章id
			this.article_id = this.$route.query.article_id;
			this.article_type = this.$route.query.article_type;
			
			this.getDetail();
		},
		methods:{
			//牛策略详情
			getDetail(){
				if(this.article_type == 1){
					this.getStrategyDetail();
				}else if(this.article_type == 2){
					this.getViewDetail();
				}else{
					this.$message({
						type:'error',
						message:'参数异常',
						onClose:() => {
							
						}
					});
					return false;
				}
			},
			//牛策略详情
			getStrategyDetail(){
				//+------------------构建请求参数----------------
				let data = {
					nclId:this.article_id,
					applicationType:this.store.state.applicationType
				}
				
				this.apiServer.bullStrategy.getDetail(data)
				.then(res => {
					// console.log('牛策略详情',res)
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message.error(res.data.data.businessMessage);
							return false;
						}
						
						// if(!res.data.data.niuContentEntity){
						// 	this.$message.error('暂无详情数据')
						// 	this.$router.go(-1);
						// 	return false;
						// }
						
						//更新牛策略详情数据
						this.strategyData = res.data.data.articleEntity;
					}
				})
				.catch(res => {
					this.$message.error('牛策略详情异常');
				});
			},
			//牛观点详情
			getViewDetail(){
				//+------------------构建请求参数----------------
				let data = {
					dvId:this.article_id,
					applicationType:this.store.state.applicationType
				}
				
				this.apiServer.bullStrategy.getViewDetail(data)
				.then(res => {
					// console.log(res)
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message.error(res.data.data.businessMessage);
							return false;
						}
						
						// if(!res.data.data.niuContentEntity){
						// 	this.$message.error('暂无详情数据')
						// 	this.$router.go(-1);
						// 	return false;
						// }
						
						//更新牛策略详情数据
						this.strategyData = res.data.data.niuContentEntity;
					}
				})
				.catch(res => {
					this.$message.error('牛策略详情异常');
				});
			},
		}
	}
</script>

<style scoped>
	.strategyDetail{
		width: 1180px;
		margin: 0 auto;
	}
	
	.page_content{
		background: #FFFFFF;
		margin-top: 41px;
	}
	.article{
		text-align: center;
	}
	.article .title{;
		height: 50px;
		font-size: 36px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 50px;
		
	}
	
	.article .desc{
		height: 25px;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 25px;
		display: flex;
		justify-content: space-around;
	}
	
	.article .content{
		
	}
	
	.article-piece{
		margin-left: 69px;
		margin-bottom: 44px;
	}
	
	.article-piece .piece{
		width: 564px;
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #C60B09;
		line-height: 33px;
	}
	
	
</style>



// WEBPACK FOOTER //
// src/components/bull_strategy/strategyDetail.vue